import FieldError from "../../../components/ui/FieldError";
import RequiredField from "../../../components/ui/RequiredField";
import Button from "../../../components/ui/Button";
import { useTranslation } from "react-i18next";

function ItemPackageForm({
  form,
  formTitle,
  onSubmitForm,
  setDefinePackaging,
  itemPackageType = "unit",
  itemPackage = null,
}) {
  const { t } = useTranslation();

  return (
    <>
      <div className="lg:text-xl pb-4 mb-6 items-center text-center">
        {formTitle}
      </div>
      <form onSubmit={form.handleSubmit(onSubmitForm)}>
        <div className="grid grid-cols-2 gap-1 my-2">
          <div className="xl:text-right">
            <label>
              {t(
                "settings.items.itemPackage.wizard." +
                  itemPackageType +
                  "_quantity"
              )}{" "}
              <RequiredField /> :
            </label>
          </div>
          <div>
            <input
              {...form.register("quantity", {
                valueAsNumber: true,
                required: t(
                  "settings.items.itemPackage.wizard." +
                    itemPackageType +
                    "_quantityRequired"
                ),
              })}
              name="quantity"
              type="number"
              className="w-full lg:w-3/6 h-10"
              defaultValue={itemPackage ? itemPackage.quantity : null}
              aria-invalid={form.formState?.errors?.quantity ? true : false}
            />
            <FieldError error={form.formState?.errors?.quantity} />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-1 my-2">
          <div className="xl:text-right">
            <label>{t("settings.items.itemPackage.wizard.barCode")} :</label>
          </div>
          <div>
            <input
              {...form.register("barCode")}
              name="barCode"
              type="text"
              className="w-full lg:w-4/6 h-10"
              defaultValue={itemPackage ? itemPackage.barCode : null}
              aria-invalid={form.formState?.errors?.barCode ? true : false}
            />
            <FieldError error={form.formState?.errors?.barCode} />
          </div>
        </div>
        {itemPackageType !== "unit" && (
          <>
            <div className="grid grid-cols-2 gap-1 my-2">
              <div className="xl:text-right">
                <label>
                  {t(
                    "settings.items.itemPackage.wizard." +
                      itemPackageType +
                      "_unitQuantity"
                  )}{" "}
                  <RequiredField /> :
                </label>
              </div>
              <div>
                <input
                  {...form.register("unitQuantity", {
                    valueAsNumber: true,
                    required: t(
                      "settings.items.itemPackage.wizard." +
                        itemPackageType +
                        "_unitQuantityRequired"
                    ),
                  })}
                  name="unitQuantity"
                  type="number"
                  className="w-full lg:w-3/6 h-10"
                  defaultValue={itemPackage ? itemPackage.unitQuantity : null}
                  aria-invalid={
                    form.formState?.errors?.unitQuantity ? true : false
                  }
                />
                <FieldError error={form.formState?.errors?.unitQuantity} />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-1 my-2">
              <div className="xl:text-right">
                <label>
                  {t(
                    "settings.items.itemPackage.wizard." +
                      itemPackageType +
                      "_packageLength"
                  )}{" "}
                  :
                </label>
              </div>
              <div>
                <input
                  {...form.register("packageLength", {
                    valueAsNumber: true,
                  })}
                  name="packageLength"
                  type="number"
                  step="0.01"
                  className="w-full lg:w-2/6 h-10"
                  defaultValue={itemPackage ? itemPackage.packageLength : null}
                  aria-invalid={
                    form.formState?.errors?.packageLength ? true : false
                  }
                />
                <FieldError error={form.formState?.errors?.packageLength} />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-1 my-2">
              <div className="xl:text-right">
                <label>
                  {t(
                    "settings.items.itemPackage.wizard." +
                      itemPackageType +
                      "_packageWidth"
                  )}{" "}
                  :
                </label>
              </div>
              <div>
                <input
                  {...form.register("packageWidth", {
                    valueAsNumber: true,
                  })}
                  name="packageWidth"
                  type="number"
                  step="0.01"
                  className="w-full lg:w-2/6 h-10"
                  defaultValue={itemPackage ? itemPackage.packageWidth : null}
                  aria-invalid={
                    form.formState?.errors?.packageWidth ? true : false
                  }
                />
                <FieldError error={form.formState?.errors?.packageWidth} />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-1 my-2">
              <div className="xl:text-right">
                <label>
                  {t(
                    "settings.items.itemPackage.wizard." +
                      itemPackageType +
                      "_packageHeight"
                  )}{" "}
                  :
                </label>
              </div>
              <div>
                <input
                  {...form.register("packageHeight", {
                    valueAsNumber: true,
                  })}
                  name="packageHeight"
                  type="number"
                  step="0.01"
                  className="w-full xl:w-2/6 h-10"
                  defaultValue={itemPackage ? itemPackage.packageHeight : null}
                  aria-invalid={
                    form.formState?.errors?.packageHeight ? true : false
                  }
                />
                <FieldError error={form.formState?.errors?.packageHeight} />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-1 my-2">
              <div className="xl:text-right">
                <label>
                  {t(
                    "settings.items.itemPackage.wizard." +
                      itemPackageType +
                      "_packageWeight"
                  )}{" "}
                  :
                </label>
              </div>
              <div>
                <input
                  {...form.register("packageWeight", {
                    valueAsNumber: true,
                  })}
                  name="packageWeight"
                  type="number"
                  step="0.01"
                  className="w-full lg:w-2/6 h-10"
                  defaultValue={itemPackage ? itemPackage.packageWeight : null}
                  aria-invalid={
                    form.formState?.errors?.packageWeight ? true : false
                  }
                />
                <FieldError error={form.formState?.errors?.packageWeight} />
              </div>
            </div>
          </>
        )}

        <div className="grid grid-cols-2 gap-1">
          <div className="col-start-2">
            <Button
              className="btn btn-primary h-10 mt-5 xl:mt-0 mb-3 xl:mb-0"
              isloading={form.formState.isSubmitting}
            >
              {t("global.btn.save")}
            </Button>
            <span
              className="cursor-pointer btn btn-default h-10 xl:ml-1"
              onClick={() => setDefinePackaging(false)}
            >
              {t("global.btn.cancel")}
            </span>
          </div>
        </div>
      </form>
    </>
  );
}

export default ItemPackageForm;
